import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2'
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import '../../components/loader.css';
import { Navigate, useNavigate, useParams } from 'react-router-dom'

const Customer_b2b_other_pricing = () => {
    const { customer_id,product_id, carrier_id } = useParams();
    console.log("product_id ==" , product_id)
    console.log("carrier_id ==" , carrier_id)

    const Cod = exportValue.COD_COMISSION;
    let navigate = useNavigate();
   
    const [state, setState] = useState({
        cod_percentage: 0, 
        cod_amount: 0, 
        fsc_charge: 0, 
        fwdfrt_charge: 0,
        rtofrt_charge: 0, 
        owner_risk: 0,
        carrier_risk_percentage: 0,
        carrier_risk_amount: 0,
        waybill_charge: 0,
        fm_cost_per_kg: 0,
        fm_cost_lr: 0,
        green_tax_per_kg: 0,
        green_tax_lr: 0,
        handling_charge_250_400_per_kg: 0,
        handling_charge_250_400_min: 0,
        handling_charge_400_plus_per_kg: 0,
        handling_charge_400_plus_min: 0,
        oda_charge_500_less_per_kg: 0,
        oda_charge_500_less_min: 0,
        oda_charge_500_plus_per_kg: 0,
        oda_charge_500_plus_min: 0,
        volumetric_weight:0,
        appointment_charge_per_kg:0,
        appointment_minimum_charge:0,
        machinery_charges:0,
        manpower_charges:0,
        adhoc_vehicle_charges:0,
        mathadi_union_charges:0,
        special_delivery_areas_charges:0,
        re_attempt_charges_per_kg: 0,
        re_attempt_minimum_charge: 0,
        csd_charges_per_kg:0,
        csd_charges_minimum_charge:0,
        demurrage_charges_per_kg:0,
        demurrage_minimum_charge:0,
        tech_charge:0,
        destination_charge:0,



    });
    
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const [loading, setLoading] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
  
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
    });
   
    // Fetch existing product data if product_id and carrier_id are present
    useEffect(() => {
        if (customer_id && product_id && carrier_id) {
            fetchProductData();
        } else {
            setLoading(false);
        }
    }, [customer_id,product_id, carrier_id]);

    const fetchProductData = async () => {
        try {
            const full_api = `${exportValue.host}/${exportValue.version}/${exportValue.api}/customer_carrier_product_get_api?customer_id=${customer_id}&carrier_id=${carrier_id}&product_id=${product_id}`;
            const response = await axios.get(full_api, { headers: exportValue.headers });
            
            if (response.data && response.data.data) {
                const productData = response.data.data[0];
                
                // Map the API data to our state structure
                const newState = {
                    cod_percentage: productData.cod_percentage || 0,
                    cod_amount: productData.cod_amount || 0,
                    fsc_charge: productData.fsc_charge || 0,
                    fwdfrt_charge: productData.fwdfrt_charge || 0,
                    rtofrt_charge: productData.rtofrt_charge || 0,
                    owner_risk: productData.owner_risk || 0,
                    carrier_risk_percentage: productData.carrier_risk_percentage || 0,
                    carrier_risk_amount: productData.carrier_risk_amount || 0,
                    waybill_charge: productData.waybill_charge || 0,
                    fm_cost_per_kg: productData.fm_cost_per_kg || 0,
                    fm_cost_lr: productData.fm_cost_lr || 0,
                    green_tax_per_kg: productData.green_tax_per_kg || 0,
                    green_tax_lr: productData.green_tax_lr || 0,
                    volumetric_weight: productData.volumetric_weight ||0,
                    appointment_charge_per_kg:productData.appointment_charge_per_kg ||0,
                    appointment_minimum_charge:productData.appointment_minimum_charge ||0,
                    machinery_charges: productData.machinery_charges ||0,
                    manpower_charges: productData.manpower_charges ||0,
                    adhoc_vehicle_charges: productData.adhoc_vehicle_charges ||0,
                    mathadi_union_charges: productData.mathadi_union_charges ||0,
                    special_delivery_areas_charges: productData.special_delivery_areas_charges ||0,
                    re_attempt_charges_per_kg: productData.re_attempt_charges_per_kg ||0,
                    re_attempt_minimum_charge: productData.re_attempt_minimum_charge ||0,
                    csd_charges_per_kg: productData.csd_charges_per_kg ||0,
                    csd_charges_minimum_charge: productData.csd_charges_minimum_charge ||0,
                    demurrage_charges_per_kg: productData.demurrage_charges_per_kg ||0,
                    demurrage_minimum_charge: productData.demurrage_minimum_charge ||0,
                    tech_charge:productData.tech_charge||0,
                    destination_charge:productData.destination_charge||0,

                };
                
                // Handle handling charges
                if (productData.handling_charges && productData.handling_charges.length > 0) {
                    const handling250_400 = productData.handling_charges.find(h => h.range_min === 250 && h.range_max === 400);
                    const handling400Plus = productData.handling_charges.find(h => h.range_min === 400 && h.range_max === null);
                    
                    if (handling250_400) {
                        newState.handling_charge_250_400_per_kg = handling250_400.charge_per_kg || 0;
                        newState.handling_charge_250_400_min = handling250_400.min_charge || 0;
                    }
                    
                    if (handling400Plus) {
                        newState.handling_charge_400_plus_per_kg = handling400Plus.charge_per_kg || 0;
                        newState.handling_charge_400_plus_min = handling400Plus.min_charge || 0;
                    }
                }
                
                // Handle ODA charges
                if (productData.oda_charges && productData.oda_charges.length > 0) {
                    const oda500Less = productData.oda_charges.find(o => o.range_min === null && o.range_max === 500);
                    const oda500Plus = productData.oda_charges.find(o => o.range_min === 500 && o.range_max === null);
                    
                    if (oda500Less) {
                        newState.oda_charge_500_less_per_kg = oda500Less.charge_per_kg || 0;
                        newState.oda_charge_500_less_min = oda500Less.min_charge || 0;
                    }
                    
                    if (oda500Plus) {
                        newState.oda_charge_500_plus_per_kg = oda500Plus.charge_per_kg || 0;
                        newState.oda_charge_500_plus_min = oda500Plus.min_charge || 0;
                    }
                }
                
                setState(newState);
            }
        } catch (error) {
            console.error("Error fetching product data:", error);
            Toast.fire({
                icon: 'error',
                title: 'Failed to load product data'
            });
        } finally {
            setLoading(false);
        }
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const saveProduct = async () => {
        setLoading(true);
        
        try {
            const endpoint =  `${exportValue.host}/${exportValue.version}/${exportValue.api}/customer_carrier_product_other_pricing_update_api`;
            
            const sendData = {
                ...(customer_id &&product_id && carrier_id ? { customer_id,product_id, carrier_id } : {}),
                fsc_charge: state.fsc_charge,
                fwdfrt_charge: state.fwdfrt_charge,
                rtofrt_charge: state.rtofrt_charge,
                owner_risk: state.owner_risk,
                carrier_risk_percentage: state.carrier_risk_percentage,
                carrier_risk_amount: state.carrier_risk_amount,
                waybill_charge: state.waybill_charge,
                fm_cost_per_kg: state.fm_cost_per_kg,
                fm_cost_lr: state.fm_cost_lr,
                green_tax_per_kg: state.green_tax_per_kg,
                green_tax_lr: state.green_tax_lr,
                volumetric_weight : state.volumetric_weight,
                appointment_charge_per_kg:state.appointment_charge_per_kg ,
                appointment_minimum_charge:state.appointment_minimum_charge ,
                machinery_charges: state.machinery_charges ,
                manpower_charges: state.manpower_charges ,
                adhoc_vehicle_charges: state.adhoc_vehicle_charges ,
                mathadi_union_charges: state.mathadi_union_charges ,
                special_delivery_areas_charges: state.special_delivery_areas_charges ,
                re_attempt_charges_per_kg: state.re_attempt_charges_per_kg ,
                    re_attempt_minimum_charge: state.re_attempt_minimum_charge ,
                    csd_charges_per_kg: state.csd_charges_per_kg ,
                    csd_charges_minimum_charge: state.csd_charges_minimum_charge ,
                    demurrage_charges_per_kg: state.demurrage_charges_per_kg ,
                    demurrage_minimum_charge: state.demurrage_minimum_charge ,
                    tech_charge:state.tech_charge,
                    destination_charge:state.destination_charge,
                handling_charges: [
                    {
                        range_min: 250,
                        range_max: 400,
                        charge_per_kg: state.handling_charge_250_400_per_kg,
                        min_charge: state.handling_charge_250_400_min
                    },
                    {
                        range_min: 400,
                        range_max: null,
                        charge_per_kg: state.handling_charge_400_plus_per_kg,
                        min_charge: state.handling_charge_400_plus_min
                    }
                ],
                oda_charges: [
                    {
                        range_min: null,
                        range_max: 500,
                        charge_per_kg: state.oda_charge_500_less_per_kg,
                        min_charge: state.oda_charge_500_less_min
                    },
                    {
                        range_min: 500,
                        range_max: null,
                        charge_per_kg: state.oda_charge_500_plus_per_kg,
                        min_charge: state.oda_charge_500_plus_min
                    }
                ],
                ...(Cod ? { 
                    cod_percentage: state.cod_percentage,
                    cod_amount: state.cod_amount
                } : {})
            };
            
            const response = await axios.post(endpoint, sendData, { headers: exportValue.headers })
               
            Toast.fire({
                icon: 'success',
                title: 'Product updated successfully' 
            });
            fetchProductData();
            // navigate('/product');
        } catch (error) {
            console.error("Error saving product:", error);
            Toast.fire({
                icon: 'error',
                title: 'Failed to save product'
            });
        } finally {
            setLoading(false);
        }
    };
   
    if (loading) {
        return (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        );
    }

    return (
       
        <div>
        <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        
        <section className="home-section">
            <Sub_header/>
        
          
            <div class="row mt-3 mb-3 justify-content-between">
        <div class="col-12 col-md-6">
            <h5>VAS Charges</h5>
            {/* <h6>B2b 200KG Heavy <small class="text-muted">(Delhivery B2b)</small></h6> */}
        </div>
    </div>

    <div class="card mb-3">
      <div class="card-body">
        <div class="row justify-content-between">
            <div class="col-12 col-md-4">
                <h3 class="fw-bold mb-3">📦 Volumetric Weight</h3>
                <div class="input-group">
                    <span class="input-group-text bg-light vas_charge_span">(LxBxH(in cm) x</span>
                    <input type="number" class="form-control" placeholder="Enter X value ex. 6 or 8" name="volumetric_weight" value={state.volumetric_weight} onChange={handleChange}/>
                    <span class="input-group-text bg-light">/ 27000</span>
                </div>
            </div>
            <div class="col-12 col-md-7">
                <div class="vas_charge">
                    <p>Calculate chargeable weight using:</p>
                    <p><strong>(Length × Breadth × Height in cm × X) / 27000</strong></p>
                    <ul>
                        <li>X = 6 for 6 CFT</li>
                        <li>X = 8 for 8 CFT</li>
                    </ul>
                    <p><strong>Example:</strong> (50 × 40 × 30 × 6) / 27000 = 13.33 kg</p>
                </div>
            </div>
        </div>
      </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">📄 Waybill Charge</h3>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Fixed Charge</span>
                <input type="number" class="form-control" placeholder="e.g. 50" name="waybill_charge" value={state.waybill_charge} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>This is a fixed charge applied on the complete shipment.</p>
                <p><strong>Example:</strong> ₹50 per shipment docket/waybill/LRN generated.</p>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">⛽ Fuel Surcharge</h3>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Fuel %</span>
                <input type="number" class="form-control" placeholder="Enter fuel % e.g. 5" name="fsc_charge" value={state.fsc_charge} onChange={handleChange}/>
                <span class="input-group-text bg-light">of Base Charge</span>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>Fuel surcharge is applied as a percentage of the base charge.</p>
                <p><strong>Formula:</strong> (Base Charge × Fuel %) / 100</p>
                <p><strong>Example:</strong> ₹100 base × 5% = ₹5 fuel surcharge</p>
                <p>The system auto-calculates the surcharge based on the entered percentage.</p>
              </div>
            </div>
          </div>
        </div>
    </div>


    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">🚚 Tech Charge</h3>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Fixed Charge</span>
                <input type="number" class="form-control" placeholder="Enter fixed freight charge" name="tech_charge" value={state.tech_charge} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>This is a fixed tech charge applied per shipment.</p>
              </div>
            </div>
          </div>
        </div>
    </div> 


     <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">🚚 Destination Charge</h3>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Rate (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="Enter fixed freight charge" name="destination_charge" value={state.destination_charge} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>If the “To destination” state is J&K, HP,Mizoram, Meghalaya, Arunachal Pradesh, Assam(except Guwahati), Tripura, Nagaland, or  Manipur , INR 5 per kg extra should be charged over and above the rate per kg from the zone matrix.</p>
             
              </div>
            </div>
          </div>
        </div>
    </div> 
    
    
    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">🛡️ Insurance / ROV</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Owner Risk</span>
                <input type="number" class="form-control" placeholder="e.g. 150" name="owner_risk" value={state.owner_risk} onChange={handleChange}/>
              </div>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Carrier Risk (%)</span>
                <input type="number" class="form-control" placeholder="e.g. 10%" name="carrier_risk_percentage" value={state.carrier_risk_percentage} onChange={handleChange} />
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Carrier Risk Amt</span>
                <input type="number" class="form-control" placeholder="e.g. 250" name="carrier_risk_amount" value={state.carrier_risk_amount} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p><strong>Owner Risk:</strong> Fixed ROV amount.</p>
                <p><strong>Carrier Risk:</strong> Either % of ROV or fixed amount is applied based on selection.</p>
                <p><strong>Example:</strong> ROV ₹2500 × 10% = ₹250</p>
              </div>
            </div>
          </div>
        </div>
    </div>


    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">💰 COD Charge</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">COD %</span>
                <input type="number" class="form-control" placeholder="e.g. 10%" name="cod_percentage" value={state.cod_percentage} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Min. Fixed Amt</span>
                <input type="number" class="form-control" placeholder="e.g. 100" name="cod_amount" value={state.cod_amount} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>COD charge is calculated on the shipment invoice amount.</p>
                <p><strong>System compares:</strong></p>
                <ul class="mb-2">
                  <li>COD % of Invoice Amount</li>
                  <li>Minimum Fixed Amount</li>
                </ul>
                <p><strong>Whichever is higher will be applied.</strong></p>
                <p><strong>Example:</strong> ₹2000 × 10% = ₹200 → ₹200 is higher than ₹100 fixed, so ₹200 will apply.</p>
              </div>
            </div>
          </div>
        </div>
    </div>
      
    
    

    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">🚚 FM Cost</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Rate (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="e.g. 10" name="fm_cost_per_kg" value={state.fm_cost_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Min. Charge (₹/LR)</span>
                <input type="number" class="form-control" placeholder="e.g. 10" name="fm_cost_lr" value={state.fm_cost_lr} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>FM charge is calculated on billed weight and adjusted with fuel surcharge.</p>
                <p><strong>Formula:</strong><br/>
                  [(Billed Weight × FM Rate) = Base] →<br/>
                  (Base + Fuel Surcharge%)</p>
                <p><strong>Min. charge per LR will apply if calculated value is lower.</strong></p>
                <p><strong>Example:</strong> 5kg × ₹10 = ₹50 + 10% fuel = ₹55</p>
              </div>
            </div>
          </div>
        </div>
    </div>
      

    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">🌿 Green Tax</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Rate (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="e.g. 100" name="green_tax_per_kg" value={state.green_tax_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Min. Charge (₹/LR)</span>
                <input type="number" class="form-control" placeholder="e.g. 9" name="green_tax_lr" value={state.green_tax_lr} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>Green Tax is applied based on billed weight or minimum LR charge — whichever is higher.</p>
                <p><strong>Applicable only for destination cities:</strong></p>
                <ul class="mb-2">
                  <li>Delhi</li>
                  <li>Faridabad</li>
                  <li>Ghaziabad</li>
                  <li>Gurgaon</li>
                  <li>Noida</li>
                </ul>
                <p><strong>Example:</strong> 0.05kg × ₹100 = ₹5 → ₹9 (min) will be applied</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    
    
    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">🛠️ Handling Charges</h3>
              <h6>250–400Kg</h6>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span"> (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="e.g. 100" name="handling_charge_250_400_per_kg" value={state.handling_charge_250_400_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group mb-3">
                <span class="input-group-text bg-light vas_charge_span">Min. (₹/LR)</span>
                <input type="number" class="form-control" placeholder="e.g. 5000" name="handling_charge_250_400_min" value={state.handling_charge_250_400_min} onChange={handleChange}/>
              </div>
              <h6>≥ 400Kg</h6>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span"> (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="e.g. 10" name="handling_charge_400_plus_per_kg" value={state.handling_charge_400_plus_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Min. (₹/LR)</span>
                <input type="number" class="form-control" placeholder="e.g. 10" name="handling_charge_400_plus_min" value={state.handling_charge_400_plus_min} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>Handling charges vary based on shipment weight range.</p>
                <ul>
                  <li><strong>250–400Kg:</strong> Charge per kg or ₹5000 min per LR (whichever is higher)</li>
                  <li><strong>400Kg and above:</strong> ₹10 per kg or ₹10 min per LR (whichever is higher)</li>
                </ul>
                <p><strong>System auto-applies based on billed weight slab.</strong></p>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">🛠️ ODA Charges</h3>
              <h6>{`<=500Kg`}</h6>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span"> (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="e.g. 100" name="oda_charge_500_less_per_kg" value={state.oda_charge_500_less_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group mb-3">
                <span class="input-group-text bg-light vas_charge_span">Min. (₹/LR)</span>
                <input type="number" class="form-control" placeholder="e.g. 5000" name="oda_charge_500_less_min" value={state.oda_charge_500_less_min} onChange={handleChange}/>
              </div>
              <h6>{`>500Kg`}</h6>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span"> (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="e.g. 10" name="oda_charge_500_plus_per_kg" value={state.oda_charge_500_plus_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Min. (₹/LR)</span>
                <input type="number" class="form-control" placeholder="e.g. 10" name="oda_charge_500_plus_min" value={state.oda_charge_500_plus_min} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>ODA charges vary based on shipment weight range.</p>
                <ul>
                  <li><strong>{`<=500Kg`}:</strong> Charge per kg or ₹5000 min per LR (whichever is higher)</li>
                  <li><strong>{`>500Kg`}and above:</strong> ₹10 per kg or ₹10 min per LR (whichever is higher)</li>
                </ul>
                <p><strong>System auto-applies based on billed weight slab.</strong></p>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">📦 Demurrage Charges</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Rate (₹/Kg/Day)</span>
                <input type="number" class="form-control" placeholder="e.g. 30" name="demurrage_charges_per_kg" value={state.demurrage_charges_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Minimum (₹/LR/Day)</span>
                <input type="number" class="form-control" placeholder="e.g. 50" name="demurrage_minimum_charge" value={state.demurrage_minimum_charge} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>Charges are applied per day as per weight or minimum per LR — <strong>whichever is higher</strong>.</p>
              </div>
            </div>
          </div>
        </div>
    </div>
      

    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">📅 Appointment Charge</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Rate (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="e.g. 10" name="appointment_charge_per_kg" value={state.appointment_charge_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Min. Charge (₹/LR)</span>
                <input type="number" class="form-control" placeholder="e.g. 100" name="appointment_minimum_charge" value={state.appointment_minimum_charge} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>Appointment charges are calculated per kg or by minimum LR value — whichever is higher.</p>
                <p><strong>Example:</strong> 5kg × ₹10 = ₹50 → If min LR is ₹100, then ₹100 will apply.</p>
              </div>
            </div>
          </div>
        </div>
    </div>

    
    
    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">⚙️ Adhoc Charges</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Machinery Charges</span>
                <input type="number" class="form-control" placeholder="Fixed ₹" name="machinery_charges" value={state.machinery_charges} onChange={handleChange}/>
              </div>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Manpower Charges</span>
                <input type="number" class="form-control" placeholder="Fixed ₹" name="manpower_charges" value={state.manpower_charges} onChange={handleChange}/>
              </div>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Vehicle Charges</span>
                <input type="number" class="form-control" placeholder="Fixed ₹" name="adhoc_vehicle_charges" value={state.adhoc_vehicle_charges} onChange={handleChange} />
              </div>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Mathadi Union</span>
                <input type="number" class="form-control" placeholder="Fixed ₹" name="mathadi_union_charges" value={state.mathadi_union_charges} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Special Area</span>
                <input type="number" class="form-control" placeholder="Fixed ₹" name="special_delivery_areas_charges" value={state.special_delivery_areas_charges} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>These are additional fixed charges applied based on specific delivery needs or handling requirements.</p>
                <ul>
                  <li>Includes Machinery, Manpower, Vehicle, Union & Special Delivery Area-based charges</li>
                  <li>Charges are applied directly and do not depend on weight</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
    </div>
    



    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">🔁 Re-attempt Charges</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">From 3rd Attempt</span>
                <input type="number" class="form-control" placeholder="e.g. 20" name="re_attempt_charges_per_kg" value={state.re_attempt_charges_per_kg} onChange={handleChange} />
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Minimum Charge</span>
                <input type="number" class="form-control" placeholder="e.g. 30" name="re_attempt_minimum_charge" value={state.re_attempt_minimum_charge} onChange={handleChange}/>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p>Applies from the <strong>3rd delivery attempt</strong> onward.</p>
                <p>Charged per Kg or a fixed minimum — <strong>whichever is higher</strong>.</p>
              </div>
            </div>
          </div>
        </div>
    </div>

    
    <div class="card mb-3">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
              <h3 class="fw-bold mb-3">📦 CSD Charges</h3>
              <div class="input-group mb-2">
                <span class="input-group-text bg-light vas_charge_span">Rate (₹/Kg)</span>
                <input type="number" class="form-control" placeholder="e.g. 10" name="csd_charges_per_kg" value={state.csd_charges_per_kg} onChange={handleChange}/>
              </div>
              <div class="input-group">
                <span class="input-group-text bg-light vas_charge_span">Minimum Charge (₹/LR)</span>
                <input type="number" class="form-control" placeholder="e.g. 40" name="csd_charges_minimum_charge" value={state.csd_charges_minimum_charge} onChange={handleChange} />
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div class="vas_charge">
                <p><strong>CSD Charges</strong> are applied per Kg or as a minimum per LR — <strong>whichever is higher</strong>.</p>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="card mb-3 mb-2">
        <div class="card-body">
          <div class="row justify-content-between">
            <div class="col-12 col-md-4">
            <button type="button" className="btn btn-primary btn-lg" onClick={saveProduct} disabled={loading}>
                             {loading ? 'Saving...' : (product_id && carrier_id ? 'Update' : 'Save')}
                         </button>
             
            </div>
            <div class="col-12 col-md-7">
             
            </div>
          </div>
        </div>
    </div>
        </section>
    </div>
    );
};

export default Customer_b2b_other_pricing;